import { render, staticRenderFns } from "./InputAmount.vue?vue&type=template&id=3858322c&"
import script from "./InputAmount.vue?vue&type=script&lang=js&"
export * from "./InputAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports